import { useRef, useState } from "react";
import { useToast } from "../../hooks/useToast";
import ToastNotification from "../common/toastNotification/ToastNotification";
import CreatePlatformSegmentModal from "./platformSegments/CreatePlatformSegmentModal";
import "./platformSegments/PlatformSegments.scss";
import "./segmentation.scss";
import SegmentsListTab from "./SegmentsListTab";

const PlatformSegmentsTab = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { showToast, toast, closeToast } = useToast();
  const segmentListRef = useRef(null);

  return (
    <div className="segment-platform-tab">
      <SegmentsListTab
        type="PLATFORM"
        handleCreateClick={() => setShowCreateModal(true)}
        ref={segmentListRef}
        showToast={showToast}
      />
      <CreatePlatformSegmentModal
        showModal={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        showToast={showToast}
        segmentListRef={segmentListRef}
      />
      <ToastNotification
        {...toast}
        handleClose={closeToast}
        primaryActionLabel={"Close"}
      />
    </div>
  );
};

export default PlatformSegmentsTab;
